import Wrapper from 'common/navigation/wrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import SubMenu from '../../common/navigation/components/sub-menu';
import MainMenu from '../../common/navigation/containers/main-menu-container';
import { ticketObjectRoutes } from '../../common/navigation/routes/cops-routes';
import TicketWorklistContainer from '../../tickets/containers/list/ticket-worklist-container';
import Dashboard from '../components/dashboard';
import Timeline from '../components/timeline';

const Technician = ({ match }) => {
  const id = match.params.technicianId;
  const renderMenu = actionButtons =>
    <MainMenu id={id} type='technician' actionButtons={actionButtons}>
      <SubMenu
        id={id}
        baseType='technician'
        base={`technician/${id}`}
        hasTickets={false}
        hasInfo={false}
        extraLinks={
          [
            {
              translationKey: 'nav.subNav.TIMELINE',
              uri: `/technician/${id}/timeline`,
              absolute: true,
            },
          ]
        }
      />
    </MainMenu>;
  const ticketRoutes = ticketObjectRoutes();
  return (
    <Wrapper>
      <Routes>
        <Route
          path={'dashboard'}
          element={<Dashboard id={id} renderMenu={renderMenu} />}
        />
        <Route
          path={'timeline/:jumpToDateOrFilter?/:filtervalue?'}
          element={<Timeline
            id={id}
            renderMenu={renderMenu}
          />
          }
        />
        {ticketRoutes?.map((r, i) => <Route
          path={`${r}/*`}
          key={i}
          element={
            <TicketWorklistContainer
              renderMenu={renderMenu}
              baseType='technician'
            />
          }
        />)}
        <Route
          path='/*'
          element={<Navigate to='dashboard' replace />}
        />
      </Routes>
      <Outlet />
    </Wrapper>
  );
};

Technician.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Technician);
